module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "status-breakdown"
  }, [_c('h3', {
    staticClass: "section-title-secondary"
  }, [_vm._v("BUY BOX STATUS BREAKDOWN")]), _vm._v(" "), _c('div', {
    staticClass: "status-cards"
  }, _vm._l((_vm.statusData), function(status) {
    return _c('div', {
      key: status.type,
      class: ['status-card', status.type, {
        active: _vm.activeType === status.type
      }],
      on: {
        "click": function($event) {
          return _vm.$emit('status-click', status.type)
        }
      }
    }, [_c('div', {
      staticClass: "status-content"
    }, [_c('div', {
      staticClass: "status-icon"
    }, [_c('i', {
      class: status.icon
    })]), _vm._v(" "), _c('div', {
      staticClass: "status-count"
    }, [_vm._v(_vm._s(status.count))]), _vm._v(" "), _c('div', {
      staticClass: "status-label"
    }, [_vm._v(_vm._s(status.label))]), _vm._v(" "), _c('div', {
      staticClass: "status-description"
    }, [_vm._v(_vm._s(status.description))])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-50a25158!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buybox/StatusBreakdown.vue
// module id = 772
// module chunks = 2